module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    attrs: {
      "id": "protocol-search"
    }
  }, [_c('span', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text",
      "name": "protocol-search",
      "placeholder": "Search For Protocols"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submitQuery()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.query == ''
    },
    on: {
      "click": function($event) {
        _vm.submitQuery()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ca8b40e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBar.vue
// module id = 236
// module chunks = 2